import { render, staticRenderFns } from "./CreateOrderShipmentLabelDialog.vue?vue&type=template&id=3abdf40a&"
import script from "./CreateOrderShipmentLabelDialog.vue?vue&type=script&lang=js&"
export * from "./CreateOrderShipmentLabelDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderShipmentLabelDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports